const isEmpty = (obj: {}) =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

const getItemInDepth = (obj: {}, keys: string[]) => {
  let res = { ...obj };
  keys.map((key) => {
    res = res?.[key];
  });

  return res;
};

export default { isEmpty, getItemInDepth };
